export enum Donated {
  ToAssociationFromIndividuals,
  ToAssociationFromLegalEntities,
  FromAssociation,
}
